import Biblioteca from '@/components/Repositorio/Biblioteca.js'

export default {
  async reprocessarProdutos(axios, parametros) {        
    parametros.operacao = 'reprocessarProdutos'

    let retorno = {}

    await axios.santriPOST('/rest/orcamento', parametros, 360, true)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data)
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined)
    })

    return retorno
  },
}


// WEBPACK FOOTER //
// ./src/components/Rest/ROrcamento/ROrcamentoReprocessarProdutos.js